import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CustomMaterialModule } from 'src/app/material-module/material.module';
import { CustomFormControlsModule } from 'src/app/shared/custom-form-controls/custom-form-controls.module';
import { ResourcefulIndexModule } from 'src/app/shared/resourceful-index/resourceful-index.module';
import { EditAnnuncioComponent } from './dialogs/edit/edit.component';
import { AnnuncioAllegatiDialogComponent } from './dialogs/allegati/annuncio-allegati.component';
import { AnnunciComponent } from './annunci.component';

@NgModule({
  declarations: [AnnunciComponent, EditAnnuncioComponent, AnnuncioAllegatiDialogComponent],
  imports: [
    CommonModule,
    CustomMaterialModule,
    FormsModule,
    ReactiveFormsModule,
    ResourcefulIndexModule,
    CustomFormControlsModule,
  ],
  exports: [AnnunciComponent, EditAnnuncioComponent]
})
export class AnnunciModule { }
